import { css, useTheme } from '@emotion/react'
import { hexToRGB } from './Utility'
import Image from 'next/image'
import { Typography } from './'

function FeatureCard({
    title,
    description,
    iconSrc,
    iconSize = 80,
    backgroundColor,
    opacity = 0.7
}) {
    const theme = useTheme()
    /* eslint-disable indent */
    const featureStyle = css`
        background-color: ${hexToRGB(
            theme.colors[backgroundColor] || theme.colors.mainBackground,
            opacity
        )};
        padding: 1rem;
        box-shadow: ${theme.boxShadow.default};
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 15rem;
        height: 15rem;
        border-radius: ${theme.borderRadius.default};
    `
    return (
        <div css={featureStyle}>
            <Image
                alt={title}
                src={iconSrc}
                width={iconSize}
                height={iconSize}
            />
            <Typography
                type="h6"
                color="secondary"
                fontWeight="Bold"
                className="pt-2"
            >
                {title}
            </Typography>
            <Typography
                type="p"
                color="secondary"
                align="center"
                fontSize="1rem"
                lineHeight={1.4}
                fontWeight="Normal"
                className="pt-2 w-40"
            >
                {description}
            </Typography>
        </div>
    )
}

export default FeatureCard
